import React, { SVGProps } from 'react'
const SvgNestedElementIndicator = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#1E2C4C"
      d="m18.37 12.75-1.94-2.262a.75.75 0 1 1 1.14-.976l3 3.5a.75.75 0 0 1 0 .976l-3 3.5a.75.75 0 0 1-1.14-.976l1.94-2.262H8.806c-3.004 0-4.557-2.04-4.557-5.75a.75.75 0 0 1 1.5 0c0 2.957.985 4.25 3.057 4.25h9.562Z"
    />
  </svg>
)
export default SvgNestedElementIndicator
